import { ThemeProvider, QueryProvider } from "../theme";
import { Layout } from "../components/Layout";

interface PageLayoutProps {
  children: React.ReactNode;
}

export default function PageLayout({ children }: PageLayoutProps) {
  return (
    <ThemeProvider>
      <QueryProvider>
        <Layout>{children}</Layout>
      </QueryProvider>
    </ThemeProvider>
  );
}
